// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d62cf21","453":"f9868307","667":"61b57bd4"}[chunkId] + ".chunk.js";
};